import React from 'react';
import '../../styles/modal/modal.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const Modal = ({ show, onClose, children, style}) => {
    if (!show) {
      return null;
    }

    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };
  
    return (
      <div className="modal-overlay" onClick={handleOverlayClick}>
        <div className= 'modal-content' onClick={(e) => e.stopPropagation()} style={style}>
          {children}
        </div>
      </div>
    );
  };
  
  export default Modal;